<template>
  <div class="foodAid">
    <div class="top">
      <div class="map_page">
        <span @click="toggleHandle('map')">地图图标</span>
      </div>
      <div class="list_page">
        <span @click="toggleHandle('agency')">机构图标</span>
      </div>
    </div>
    <div id="container" class="container"></div>
  </div>
</template>

<script>
import AMap from "AMap";
import yljg from "@/assets/images/yljg-s.png";
import zcd from "@/assets/images/zcd-s.png";
import fjzl from "@/assets/images/fjzl-s.png";
// import wsxm from "../../assets/images/fwxm-s.png";
import ggss from "@/assets/images/ggss-s.png";
import wsfw from "@/assets/images/fwcs-s.png";
export default {
  name: "foodAid",
  data() {
    return {
      centerCo: [121.403107, 31.009136],
      map: "",
      mapList: [
        {
          arr: [121.391363, 31.024828],
          name: "养老院",
          class: "yljg",
          type: yljg
        },
        {
          arr: [121.406212, 31.019898],
          name: "助餐点",
          class: "zcd",
          type: zcd
        },
        {
          arr: [121.389217, 31.01504],
          name: "辅具租赁点",
          class: "fhzld",
          type: fjzl
        },
        {
          arr: [121.404409, 31.006722],
          name: "为老服务场所",
          class: "wlfw",
          type: wsfw
        },
        {
          arr: [121.393423, 30.99892],
          name: "公共设施",
          class: "ggss",
          type: ggss
        }
        // {
        //   arr: [121.49659, 31.077],
        //   name: "为老服务项目",
        //   class: "wlfwd",
        //   type: wsxm
        // }
      ]
    };
  },
  methods: {
    toggleHandle(name) {
      this.$router.push(name);
    },
    init() {
      return new Promise(() => {
        var map = new AMap.Map("container", {
          center: this.centerCo,
          resizeEnable: true,
          zoom: 14,
          scrollWheel: true
        });

        let _this = this;
        this.mapList.forEach(item => {
          var content =
            "<div class='marker-list " +
            item.class +
            "'>" +
            "<div class='marker-list-img'><img src='" +
            item.type +
            "'></div><div class='marker-list-content'><div class='marker-list-name'>" +
            item.name +
            "</div><div class='marker-list-num'>" +
            item.num +
            "</div></div>" +
            "</div>";
          const marker = new AMap.Marker({
            map: map,
            content: content,
            offset: new AMap.Pixel(-10, -50),
            position: new AMap.LngLat(item.arr[0], item.arr[1]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.name
          });
          AMap.event.addListener(marker, "click", function() {
            _this.$router.push({
              path: "/mapTb",
              query: {
                id: item.name
              }
            });
          });
          map.add(marker);
        });
        this.map = map;
      });
    }
    // getMapNewList() {
    //   return new Promise(resolve => {
    //     getMapList({ areaCode: areaCode.areaCode }).then(res => {
    //       if (res.code === 0) {
    //         this.mapList[0].num = res.data.mechanism;
    //         this.mapList[1].num = res.data.mealAid;
    //         this.mapList[2].num = res.data.rentalPoint;
    //         this.mapList[3].num = res.data.servingTheOldPlace;
    //         this.mapList[4].num = res.data.communalFacilities + 7;
    //         // this.mapList[5].num = res.data.communalFacilities;
    //       }
    //       resolve();
    //     });
    //   });
    // },
    // async getData() {
    //   await this.getMapNewList();
    //   await this.init();
    // }
  },
  mounted() {
    // this.getData();
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.foodAid {
  position: relative;
  .top {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 9999;
    display: flex;
    flex-direction: row-reverse;
    .map_page,
    .list_page {
      margin-right: 15px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #ffd63c;
    }
  }
  .container {
    height: calc(100vh - 50px);
  }
}
</style>
